import CRMPermission from '@/models/enums/permissions/CRMPermission'
export default [
    {
        path: '/administrator',
        name: 'Администратор',
        component: () => import('../../pages/Administrator/Administrator.vue'),
      },
      {
        path: '/administrator/work-shift',
        name: 'Смена',
        component: () => import('../../pages/Administrator/WorkShift.vue'),
      },
      {
        path: '/administrator/cashier',
        name: 'cashier',
        component: () => import('../../pages/Administrator/Cashier.vue'),
        meta: {
          pageTitle: 'Касса',
          permissions: [CRMPermission.ViewCashBox],
        },
      },
      {
        path: '/administrator/shift-schedule',
        name: 'График смен',
        component: () => import('../../pages/Administrator/DayWorkSchedule.vue'),
        meta: {
          permissions: ['crm.work_schedule.view'],
        },
      },
      /* {
        path: '/administrator/shift-schedule-old',
        name: 'График смен old',
        component: () => import('./../pages/Administrator/ShiftSchedule'),
      }, */
]
